import InfoBubble from './InfoBubble';

export default InfoBubble;
